import { StepList } from 'components/StepList/StepList';
import { useSelector } from 'react-redux';
import type { RootState } from 'reducers/types';
import {
  getCurrentStepIndex,
  getPaymentSteps,
  isEmbedded as isEmbeddedSelector,
} from 'selectors';
import { getPaymentStepsForIndia } from 'selectors/ui/india/ui';

type PaymentStepListProps = {
  isNewIndiaFlow?: boolean;
};

const PaymentStepList = ({ isNewIndiaFlow = false }: PaymentStepListProps) => {
  const activeStepIndex = useSelector(getCurrentStepIndex);
  const isEmbedded = useSelector(isEmbeddedSelector);
  const steps = useSelector((state: RootState) =>
    isNewIndiaFlow ? getPaymentStepsForIndia(state) : getPaymentSteps(state),
  );

  if (isEmbedded) {
    return null;
  }

  // we need to add 1 to the activeStepIndex because the first step is not included in the steps array
  // and we need to show the progress bar as 1 step ahead
  return (
    <StepList
      activeStepIndex={activeStepIndex + 1}
      totalSteps={steps.length + 1}
      isNewIndiaFlow={isNewIndiaFlow}
    />
  );
};

export { PaymentStepList };
